import { useMemo } from "react";
import { useLCID } from "../../../locale";
import { isMeasureItemDTO, isFieldItemDTO, useDataSourcesQuery, useDimensionItemsQuery } from "../../api";
import { useBulkExportContext } from "../../providers";
import { BulkExportFormatEnum } from "../../api/mutations/saveBulkExportState/saveBulkExportState.types";
import { virtualConfiguration } from "../../components/BulkExportStepper";
import { IDimension } from "../../types";

export function useBulkExportSettingsSave(currentDimensions?: IDimension[], currentdataSourceId?: number, fileFormat?: BulkExportFormatEnum) {
  const context = useBulkExportContext();
  const lcid = useLCID();
  const { dataSources } = useDataSourcesQuery();

  const state = context?.state;
  const dataSourceId = currentdataSourceId ?? state?.dataSourceId;
  const dimensions = currentDimensions ?? state?.dimensions ?? [];
  const format = fileFormat ?? state?.format ? BulkExportFormatEnum[state!.format]! : undefined;

  const { dimensionItems: configurationItems } = useDimensionItemsQuery(lcid, dataSourceId, virtualConfiguration.identifier);

  const configuration = dimensions?.find((d) => d.id === virtualConfiguration.hierarchyIdentifier);

  return useMemo(() => {
    if (!dataSourceId) {
      return null;
    }

    const selectedMeasures = configurationItems?.filter(isMeasureItemDTO).filter((it) => configuration?.selection.includes(it.id)) || [];
    const selectedFields = configurationItems?.filter(isFieldItemDTO).filter((it) => configuration?.selection.includes(it.id));
    const chosenConfiguration = dimensions?.find((d) => d.id === virtualConfiguration.hierarchyIdentifier);

    const dataSource = dataSources!.find((d) => d.id === dataSourceId)!;
    const cubeId = dataSource?.identifier;
    const finalDimension = dimensions
      ?.filter((d) => d.id !== virtualConfiguration.hierarchyIdentifier)
      .map((dimension) => {
        const dimensionId = dimension.id;
        const fieldNameItem = selectedFields?.find((field) => field.id.toString().includes(dimensionId));
        const fieldName = fieldNameItem?.name ?? "";
        return {
          ...dimension,
          fieldName,
          isSelected: !!fieldName,
        };
      });
    chosenConfiguration?.selection.forEach((el) => {
      if (!finalDimension?.find((dim) => `${el}`.includes(dim.id))) {
        finalDimension?.push({
          selection: [],
          isSelected: true,
          fieldName: configurationItems?.find((field) => field.id.toString() === el)?.name || "",
          id: `${el}`.replace(".name", ""),
        });
      }
    });

    const finalMeasures = selectedMeasures?.map((measure) => ({
      fieldName: measure.name,
      id: measure.id as string,
      isSelected: true,
    }));
   
    const settings = {
      measures: finalMeasures,
      dimensions: finalDimension,
      cubeId,
      format,
      lastUpdate: dataSource?.lastUpdate!,
    };

    return settings;
  }, [
    state,
    dataSources,
    configuration,
    configurationItems,
    dimensions,
    currentDimensions,
    currentdataSourceId,
    fileFormat,
  ]);
}
